export const COLOR_PALETTE: string[] = [
	"#33ff33", // p1 green
	"#cc00cc", // ibm magenta
	"#ff7b6b", // rose
	"#8df27f", // mint
	"#c8a8ff", // lilac
	"#ffc89e", // peach
	"#c8e89a", // pistachio
	"#e8d49a", // sand
	"#9ce8c8", // seafoam
	"#ff3d8a", // hot pink
	"#aaff00", // acid green
	"#d63dff", // plasma
	"#ff5a1f", // flame
	"#fff03d", // lemon
	"#ff9495", // coral
	"#fa9d68", // apricot
	"#adc35e", // chartreuse
	"#61d19a", // jade
	"#a7adff", // periwinkle
	"#dc9beb", // orchid
	"#f594c3", // flamingo
];
